import Vue from 'vue';

export default {
  state: {
    agents: [],
  },
  getters: {
    agents(state) {
      return state.agents;
    },
    agent: state => id => state.agents.find(agent => agent.id === id) || {},
  },
  mutations: {
    SET_AGENTS(state, payload) {
      state.agents = payload;
    },
  },
  actions: {
    GET_AGENTS(context) {
      return Vue.axios.get('filters/agents').then((response) => {
        context.commit('SET_AGENTS', response.data);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/agents.js